import { Event } from '../models/event.model';

export interface EventsState {
  items: Event[];
  loading: boolean;
  error: string | null;
}

export const initialState: EventsState = {
  items: [],
  loading: false,
  error: null,
};
